import React from 'react'
import Navbar from '../header/Navbar'
import Footer from '../footer/Footer'
import ExpenseManager from '../games/other/ExpenseManager'

const Profile = () => {
  return (
    <div>
      <Navbar/>
      <ExpenseManager/>
      <Footer/>
    </div>
  )
}

export default Profile